<template>
  <div>
    <!-- Search筛选 -->
    <el-form :inline="true" :model="params" class="user-search">
      <el-form-item label="">
        <el-cascader :options="country_business" size="small"
          :props="{ checkStrictly: true, value: 'name', label: 'name', expandTrigger: 'hover' }" clearable
          placeholder="Country/Business" @change="cascaderChange" style="position:relative;right:2px">
        </el-cascader>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker v-model="params.success_time" type="daterange" size="small" value-format="yyyy-MM-dd"
          align="right" unlink-panels start-placeholder="Start date" end-placeholder="End date"
          :picker-options="pickerOptions" clearable>
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">Search</el-button>
        <el-button type="success" size="small" icon="el-icon-document" @click="exportExcel">Export</el-button>
      </el-form-item>
    </el-form>
    
    <div class="balance" v-if="balanceInfo">
      <div class="balance-header">
        <span>商户：{{ balanceInfo.business_name }}</span>
        <span>账面余额：{{ balanceInfo.balance }}</span>
        <span>代付占用（含费用）：{{ balanceInfo.pending_debit }}</span>
        <span>可申请余额：{{ balanceInfo.available_balance }}</span>
      </div>
      <div class="balance-line">{{ balanceInfo.formula_result }}</div>
      <div class="balance-formula">{{ balanceInfo.formula_text }}</div>
    </div>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" element-loading-text="Loading..."
      style="width: 1802px">
      <el-table-column prop="business_name" label="Business" width="120">
        <template slot-scope="scope">
          <div>{{ scope.row.business_name }}</div>
          <div>{{ scope.row.country }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="reserved_num" label="Recharge" width="190">
        <template slot-scope="scope">
          <div><span style="color:#909399">Num：</span>{{ scope.row.reserved_num }}</div>
          <div><span style="color:#909399">Amount：</span>{{ scope.row.reserved_amount }}</div>
          <div><span style="color:#909399">Fee：</span>{{ scope.row.reserved_fee }}</div>
          <div><span style="color:#909399">Total Num：</span>{{ scope.row.reserved_num_grand_total }}</div>
          <div><span style="color:#909399">Total Amount：</span>{{ scope.row.reserved_amount_grand_total }}</div>
          <div><span style="color:#909399">Total Fee：</span>{{ scope.row.reserved_fee_grand_total }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="transaction_num" label="Withdraw" width="190">
        <template slot-scope="scope">
          <div><span style="color:#909399">Num：：</span>{{ scope.row.transaction_num }}</div>
          <div><span style="color:#909399">Amount：：</span>{{ scope.row.transaction_amount }}</div>
          <div><span style="color:#909399">Fee：</span>{{ scope.row.transaction_fee }}</div>
          <div><span style="color:#909399">Total Num：：</span>{{ scope.row.transaction_num_grand_total }}</div>
          <div><span style="color:#909399">Total Amount：：</span>{{ scope.row.transaction_amount_grand_total }}</div>
          <div><span style="color:#909399">Total Fee：</span>{{ scope.row.transaction_fee_grand_total }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="refund_reserved_num" label="Recharge Refund" width="190">
        <template slot-scope="scope">
          <div><span style="color:#909399">Num：</span>{{ scope.row.refund_reserved_num }}</div>
          <div><span style="color:#909399">Amount：</span>{{ scope.row.refund_reserved_amount }}</div>
          <div><span style="color:#909399">Total Num：</span>{{ scope.row.refund_reserved_num_grand_total }}</div>
          <div><span style="color:#909399">Total Amount：</span>{{ scope.row.refund_reserved_amount_grand_total }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="refund_transaction_num" label="Withdraw Refund" width="190">
        <template slot-scope="scope">
          <div><span style="color:#909399">Num：</span>{{ scope.row.refund_transaction_num }}</div>
          <div><span style="color:#909399">Amount：</span>{{ scope.row.refund_transaction_amount }}</div>
          <div><span style="color:#909399">Total Num：</span>{{ scope.row.refund_transaction_num_grand_total }}</div>
          <div><span style="color:#909399">Total Amount：</span>{{ scope.row.refund_transaction_amount_grand_total }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="lock_num" label="Lock" width="190">
        <template slot-scope="scope">
          <div><span style="color:#909399">Num：</span>{{ scope.row.lock_num }}</div>
          <div><span style="color:#909399">Amount：</span>{{ scope.row.lock_amount }}</div>
          <div><span style="color:#909399">Total Num：</span>{{ scope.row.lock_num_grand_total }}</div>
          <div><span style="color:#909399">Total Amount：</span>{{ scope.row.lock_amount_grand_total }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="withdrawal_num" label="Transfer out Funds" width="190">
        <template slot-scope="scope">
          <div><span style="color:#909399">Num：</span>{{ scope.row.withdrawal_num }}</div>
          <div><span style="color:#909399">Amount：</span>{{ scope.row.withdrawal_amount }}</div>
          <div><span style="color:#909399">Total Num：</span>{{ scope.row.withdrawal_num_grand_total }}</div>
          <div><span style="color:#909399">Total Amount：</span>{{ scope.row.withdrawal_amount_grand_total }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="exchange_rate_diff_num" label="Recharge Rate Diff" width="190">
        <template slot-scope="scope">
          <div><span style="color:#909399">Num：</span>{{ scope.row.exchange_rate_diff_num }}</div>
          <div><span style="color:#909399">Amount：</span>{{ scope.row.exchange_rate_diff_amount }}</div>
          <div><span style="color:#909399">Total Num：</span>{{ scope.row.exchange_rate_diff_num_grand_total }}</div>
          <div><span style="color:#909399">Total Amount：</span>{{ scope.row.exchange_rate_diff_amount_grand_total }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="internal_recharge_num" label="Internal Recharge" width="190">
        <template slot-scope="scope">
          <div><span style="color:#909399">Num：</span>{{ scope.row.internal_recharge_num }}</div>
          <div><span style="color:#909399">Amount：</span>{{ scope.row.internal_recharge_amount }}</div>
          <div><span style="color:#909399">Total Num：</span>{{ scope.row.internal_recharge_num_grand_total }}</div>
          <div><span style="color:#909399">Total Amount：</span>{{ scope.row.internal_recharge_amount_grand_total }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="success_time" label="statistical date" width="160">
        <template slot-scope="scope">
          <div><span style="color:#909399">Statistics：</span>{{ scope.row.success_time | timestampToDate }}</div>
          <div v-if="scope.row.add_time"><span style="color:#909399">Add：</span>{{ scope.row.add_time | timestampToDate }}</div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
import {
  businessBill,
  getCountryBusiness,
} from '../../api/apiFun'
import {
  timestampToTime,
  timestampToDate,
  exportUrl,
  cascaderChange
} from '@/utils/util';
import Pagination from '../../components/Pagination'
let that = ""
export default {
  data() {
    return {
      loading: false, //是显示加载
      examineVisible: false, //控制Edit页面显示与隐藏
      params: {
        page: 1,
        limit: 10,
        success_time: '',
        country: '',
        business_name: '',
      },
      business_list: [],
      country_business: [],
      listData: [], //User数据
      balanceInfo: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      pickerOptions: {
        shortcuts: [{
          text: 'Today',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last week',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last month',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  filters: {
    timestampToTime: function (timestamp) {
      return timestampToTime(timestamp)
    },
    timestampToDate: function (timestamp) {
      return timestampToDate(timestamp)
    },
  },
  created() {
    that = this
    this.getdata(this.params)
    this.getCountryBusiness()
  },
  methods: {
    cascaderChange(value) {
      var cascader = cascaderChange(value)
      this.params.country = cascader[0]
      this.params.business_name = cascader[1]
    },
    getCountryBusiness() {
      getCountryBusiness().then(res => {
        if (res.code == 400) {
          this.$message({
            state: 'info',
            message: res.msg
          })
        } else {
          this.country_business = res.datas;
        }
      }).catch(err => {
        this.$message.error('Failed to obtain business list, please try again later!')
      })
    },
    exportExcel() {
      window.location.href = exportUrl('/admin/business/export_bill', this.params);
    },
    // 获取Statistical settlement
    getdata(parameter) {
      if (parameter.success_time == null) {
        parameter.success_time = ''
      }
      this.loading = true
      businessBill(parameter).then(res => {
        this.loading = false
        if (res.code == 400) {
          this.$message({
            state: 'info',
            message: res.msg
          })
        } else {
          this.listData = res.datas.list
          this.balanceInfo = res.datas.balance_info || ''
          // 分页赋值
          this.pageparm.currentPage = this.params.page
          this.pageparm.pageSize = this.params.limit
          this.pageparm.total = res.datas.count
        }
      }).catch(err => {
        this.loading = false
        this.$message.error('Failed to obtain statistical settlement, please try again later!')
      })
    },
    // 分页插件事件
    callFather(parm) {
      this.params.page = parm.currentPage
      this.params.limit = parm.pageSize
      this.getdata(this.params)
    },
    // Search事件
    search() {
      this.params.page = 1
      this.getdata(this.params)
    },
  }
}

</script>

<style scoped>
.el-image__error {
  font-size: 12px !important;
}

.user-search {
  margin-top: 20px;
}

.balance {
  margin: 0 0 12px 0;
  padding: 12px 14px;
  border: 1px solid #dbeafe;
  border-left: 4px solid #00bcd4;
  border-radius: 6px;
  background: #f8fcff;
  color: #1f2d3d;
  line-height: 1.7;
  box-shadow: 0 1px 4px rgba(31, 45, 61, 0.04);
}

.balance-header {
  display: flex;
  flex-wrap: wrap;
  gap: 10px 24px;
  font-size: 14px;
  font-weight: 600;
  color: #0b3a53;
}

.balance-line,
.balance-formula {
  margin-top: 4px;
  font-size: 13px;
  word-break: break-word;
}

.balance-formula {
  color: #5f6b7a;
}

.userRole {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/business/bill.vue